






















import LazyImage from "@/components/LazyImage.vue";
import Vue, { PropType } from "vue";
import { Product } from "@/models";

export default Vue.extend({
  name: "Product",
  components: { LazyImage },
  props: {
    productId: {
      type: Number as PropType<number>,
      default: 1
    }
  },
  computed: {
    product(): Product {
      return (this.$t("products." + this.productId) as unknown) as Product;
    }
  }
});
